module.exports = __webpack_public_path__ + "static/media/sad-smiley.aec34ea0.svg";